/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 *
 * See codegen config in .graphqlrc.yml for details
 */

import gql from 'graphql-tag';
import * as Urql from 'urql';

import type * as Types from '@sg/graphql-schema';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type ClaimLoyaltyPromotionMutationVariables = Types.Exact<{
  input: Types.ClaimLoyaltyPromotionInput;
}>;

export type ClaimLoyaltyPromotionMutation = {
  readonly __typename?: 'Mutation';
  readonly claimLoyaltyPromotion:
    | {
        readonly __typename: 'ClaimLoyaltyPromotionFailure';
        readonly reason: Types.ClaimLoyaltyPromotionFailureReason;
        readonly errorMessage: string;
      }
    | {
        readonly __typename: 'Reward';
        readonly id: string;
        readonly redeemable: boolean;
        readonly isFeatured: boolean;
        readonly redeemableAt: string | null;
        readonly rewardType: Types.RewardType;
        readonly expirationDate: string | null;
        readonly name: string;
        readonly redemptionChannel: Types.RedemptionChannel;
        readonly assetUrl: string | null;
        readonly terms: string;
      };
};

export const ClaimLoyaltyPromotionDocument = gql`
  mutation claimLoyaltyPromotion($input: ClaimLoyaltyPromotionInput!) {
    claimLoyaltyPromotion(input: $input) {
      ... on Reward {
        id
        __typename
        redeemable
        isFeatured
        redeemableAt
        rewardType
        expirationDate
        name
        redemptionChannel
        assetUrl
        terms
      }
      ... on ClaimLoyaltyPromotionFailure {
        __typename
        reason
        errorMessage
      }
    }
  }
`;

export function useClaimLoyaltyPromotionMutation() {
  return Urql.useMutation<ClaimLoyaltyPromotionMutation, ClaimLoyaltyPromotionMutationVariables>(
    ClaimLoyaltyPromotionDocument,
  );
}
